import React from 'react';

const FileAttachedFileIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      width={props.width || 24}
      height={props.height || 33}
      viewBox="0 0 24 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4854_5370)">
        <path
          d="M21.0013 29.5013V11.4987H14.4956C14.2985 11.4987 14.1033 11.4598 13.9214 11.384C13.7394 11.3083 13.5742 11.1973 13.4353 11.0575C13.2964 10.9176 13.1866 10.7517 13.1121 10.5692C13.0376 10.3868 12.9999 10.1914 13.0013 9.99429V3.54956H3.04956V29.5013H21.0013ZM16 3.7427V8.5H20.7573L16 3.7427ZM24 8.74397V29.5013C23.9869 30.2925 23.6668 31.0477 23.1072 31.6072C22.5477 32.1668 21.7925 32.4869 21.0013 32.5H3.04956C2.24949 32.5001 1.48143 32.1858 0.910967 31.6249C0.340503 31.0639 0.0133344 30.3012 0 29.5013L0 3.54956C0 2.74077 0.321292 1.9651 0.893194 1.3932C1.4651 0.821295 2.24076 0.500004 3.04956 0.500004H15.756C16.1496 0.499357 16.5393 0.577242 16.9023 0.729099C17.2654 0.880956 17.5945 1.10373 17.8704 1.38438L23.1156 6.59911C23.6815 7.16963 23.9993 7.94042 24 8.74397ZM17.2808 20.4949H6.74968C6.55018 20.4949 6.35885 20.5742 6.21778 20.7152C6.07671 20.8563 5.99746 21.0476 5.99746 21.2471V22.9956C5.99746 23.1951 6.07671 23.3864 6.21778 23.5275C6.35885 23.6685 6.55018 23.7478 6.74968 23.7478H17.2808C17.4803 23.7478 17.6716 23.6685 17.8127 23.5275C17.9538 23.3864 18.033 23.1951 18.033 22.9956V21.2471C18.033 21.0476 17.9538 20.8563 17.8127 20.7152C17.6716 20.5742 17.4803 20.4949 17.2808 20.4949ZM18.033 16.0019V17.7808C18.0304 17.9795 17.9503 18.1693 17.8098 18.3098C17.6693 18.4503 17.4795 18.5304 17.2808 18.533H6.74968C6.55018 18.533 6.35885 18.4538 6.21778 18.3127C6.07671 18.1716 5.99746 17.9803 5.99746 17.7808V16.0019C5.99746 15.8024 6.07671 15.6111 6.21778 15.47C6.35885 15.3289 6.55018 15.2497 6.74968 15.2497H17.2808C17.475 15.2576 17.6586 15.3403 17.7931 15.4805C17.9277 15.6207 18.0027 15.8076 18.0025 16.0019H18.033Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4854_5370">
          <rect width="24" height="32" fill="currentColor" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FileAttachedFileIcon;
